import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import RegisterPage from '../components/RegisterPage';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequestAsync, APIRequest, getHeaders } from '../api/client';
import UserInfoForm from './register/UserInfoForm';

export interface UserRegistration {
  name: string;
  country: string;
  email: string;
  password: string;
  company_name?: string;
}

const acceptInvitation = (
  context: ProfileManager,
  id: string,
): [APIRequest, Function] => {
  const [state, submit] = useRequestAsync((data: UserRegistration) => ({
    url: `/invitations/${id}/accept`,
    method: 'POST',
    body: JSON.stringify(data),
    headers: getHeaders(context),
  }));

  React.useEffect(() => {
    if (!state.data) {
      return;
    }

    context.set(state.data);
  }, [state]);

  return [state, submit];
};

const getEntityID = (props: RouteComponentProps<any>) =>
  props.match.params.token;

interface Props extends RouteComponentProps<any> {}

export default function Register(props: Props) {
  const context: any = React.useContext(ProfileContext);
  const invitationID = getEntityID(props);

  const [userCountry, setUserCountry] = React.useState(null);
  const [userName, setUserName] = React.useState(null);
  const [userEmail, setUserEmail] = React.useState(null);
  const [userPassword, setUserPassword] = React.useState(null);
  const [step, setStep] = React.useState(0);

  const [state, submit] = acceptInvitation(context, invitationID);

  const getForm = (step: number) => {
    return (
      <UserInfoForm
        userCountry={userCountry}
        userName={userName}
        userEmail={userEmail}
        setUserCountry={setUserCountry}
        setUserName={setUserName}
        setUserEmail={setUserEmail}
        setUserPassword={setUserPassword}
      />
    );
  };

  if (state.complete && state.data) {
    props.history.push('/dashboard');
    return <Loader />;
  }

  return (
    <RegisterPage {...props}>
      <form
        className="pa4 black-80 ml-auto mr-auto w-70-ns"
        method="POST"
        onSubmit={(e) => {
          e.preventDefault();

          submit({
            country: userCountry,
            name: userName,
            email: userEmail,
            password: userPassword,
          });
        }}
      >
        <h3 className="f3 f2-ns lh-title ma0 mb2 black">Accept invitation</h3>
        <small className="f6 black-60 db mb4 lh-copy">
          Register an account to manage the business profile.
        </small>
        {state.error && <ErrorFlash error={state.error} />}
        {state.loading ? <Loader /> : getForm(step)}
        <button
          className="mv3 mv4-ns db link gold f3 b bw0 bg-ui-white-1 tl pa0 dim pointer bg-animate"
          type="submit"
          disabled={state.loading}
        >
          Continue
        </button>
      </form>
    </RegisterPage>
  );
}
